/**
 * 用户 store（架构 §2 src/store/user.store.ts / T09 / T11 / T01）
 *  - me：当前用户（GET /user/me，含 stats）
 *  - myFiles：我的产出（知会为我生成的文件聚合）
 *  - activity：最近活动流（GET /user/activity）
 *  - knownUsers：已知用户目录（id -> PublicUser），用于 @提及 与 私聊/加人候选
 *     （后端 members 接口只返回 user_id，不含 username，故用已知目录补全展示名）
 */
import { create } from 'zustand';
import type { PublicUser, MyFile, MeUser, ActivityItem } from '../types/models';

interface UserState {
  me: MeUser | null;
  myFiles: MyFile[];
  knownUsers: Record<number, PublicUser>;
  activity: ActivityItem[];
  activityTotal: number;

  setProfile: (me: MeUser, myFiles: MyFile[]) => void;
  setActivity: (items: ActivityItem[], total: number) => void;
  addKnownUser: (user: PublicUser) => void;
  reset: () => void;
}

export const useUserStore = create<UserState>((set, get) => ({
  me: null,
  myFiles: [],
  knownUsers: {},
  activity: [],
  activityTotal: 0,

  setProfile: (me, myFiles) => {
    const known = { ...get().knownUsers, [me.id]: me };
    set({ me, myFiles, knownUsers: known });
  },
  setActivity: (activity, activityTotal) => set({ activity, activityTotal }),
  addKnownUser: (user) =>
    set((s) => ({ knownUsers: { ...s.knownUsers, [user.id]: user } })),
  reset: () => set({ me: null, myFiles: [], knownUsers: {}, activity: [], activityTotal: 0 }),
}));
